import { AlphaFCircleIcon } from './AlphaFCircleIcon';

/**
 * author: Contributors
 * id 317A9E55-62CC-4A55-B851-483EB546D022
 * name alpha-f-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-f-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetFCircleIcon = AlphaFCircleIcon;
export default AlphabetFCircleIcon